export var SapEventKind;
(function (SapEventKind) {
    SapEventKind["SAP_EVENT_KIND_AGENT_ONLINE"] = "AGENT_ONLINE";
    SapEventKind["SAP_EVENT_KIND_AGENT_OFFLINE"] = "AGENT_OFFLINE";
    SapEventKind["SAP_EVENT_KIND_SCHEMA_DRIFT"] = "SCHEMA_DRIFT";
    SapEventKind["SAP_EVENT_KIND_AUTH_FAILURE"] = "AUTH_FAILURE";
    SapEventKind["SAP_EVENT_KIND_NETWORK_GLITCH"] = "NETWORK_GLITCH";
    SapEventKind["SAP_EVENT_KIND_EXTRACT_STARTED"] = "EXTRACT_STARTED";
    SapEventKind["SAP_EVENT_KIND_EXTRACT_COMPLETED"] = "EXTRACT_COMPLETED";
    SapEventKind["SAP_EVENT_KIND_CATALOG_STARTED"] = "CATALOG_STARTED";
    SapEventKind["SAP_EVENT_KIND_CATALOG_COMPLETED"] = "CATALOG_COMPLETED";
    SapEventKind["SAP_EVENT_KIND_BULK_STARTED"] = "BULK_STARTED";
    SapEventKind["SAP_EVENT_KIND_BULK_COMPLETED"] = "BULK_COMPLETED";
    SapEventKind["SAP_EVENT_KIND_DELTA_STARTED"] = "DELTA_STARTED";
    SapEventKind["SAP_EVENT_KIND_PAUSED"] = "PAUSED";
    SapEventKind["SAP_EVENT_KIND_RESUMED"] = "RESUMED";
})(SapEventKind || (SapEventKind = {}));
